package com.devi3east.bashbuddy.purchase.domain.models

import com.devi3east.bashbuddy.cart.responses.TicketPurchaseResponse
import com.devi3east.bashbuddy.features.events.common.data.models.Event
import com.devi3east.bashbuddy.features.events.common.data.models.Ticket
import com.devi3east.bashbuddy.features.events.common.data.models.TicketType
import kotlinx.datetime.Instant

data class PurchaseUiModel(
    val purchaseId: String,
    val status: PurchaseStatus,
    val createdAtInstant: Instant,
    val items: List<PurchaseItemUiModel>
)

data class PurchaseItemUiModel(
    val eventId: String,
    val eventTitle: String,
    val startInstant: Instant?,
    val endInstant: Instant?,
    val eventImage: String,
    val eventCity: String,
    val eventState: String,
    val eventZip: String,
    val createdBy: String,
    val ticketType: TicketType,
    val ticketId: String,
    val ticketTitle: String,
    val serialNumber: String,
    val chancesPerTicket: Int,
    val quantity: Int,
    val unitAmountCents: Long,
    val totalCents: Long,
    val fiftyFiftyJackpot: Long,
    val chanceNumbers: List<String> = emptyList(),
    val allocations: List<PurchaseAllocationUiModel> = emptyList(), // ✅ added
    val organizationId: String? = null,
    val checkoutSessionUrl: String? = null,
    val slug: String
)

data class PurchaseAllocationUiModel(
    val allocationId: String,
    val chanceNumbers: List<String> = emptyList()
)

fun TicketPurchaseResponse.toUiModel(
    events: List<Event>,
    tickets: List<Ticket>
): PurchaseUiModel {
    return PurchaseUiModel(
        purchaseId = _id,
        status = status,
        createdAtInstant = createdAtInstant,
        items = subPurchases.flatMap { sub ->
            sub.items.map { item ->
                val event = events.find { it._id == item.eventId }
                val ticket = tickets.find { it._id == item.ticketId }

                PurchaseItemUiModel(
                    eventId = item.eventId,
                    eventTitle = event?.title ?: "Unknown Event",
                    startInstant = event?.startInstant,
                    endInstant = event?.endInstant,
                    eventImage = event?.imageUrl ?: "Unknown Image",
                    eventCity = event?.address?.city ?: "Unknown City",
                    eventState = event?.address?.state ?: "Unknown State",
                    eventZip = event?.address?.zipCode ?: "Unknown Zip",
                    createdBy = event?.createdByName ?: "Unknown Organizer",
                    ticketType = ticket?.ticketType ?: TicketType.DIGITAL,
                    ticketId = item.ticketId,
                    ticketTitle = ticket?.title ?: "Unknown Ticket",
                    serialNumber = ticket?.serialNumber ?: "",
                    chancesPerTicket = ticket?.chancesPerTicket ?: 1,
                    quantity = item.quantity,
                    unitAmountCents = item.unitAmountCents,
                    totalCents = item.totalCents,
                    fiftyFiftyJackpot = event?.fiftyFiftyJackpot ?: 0,
                    chanceNumbers = item.allocations.flatMap { it.chanceNumbers },
                    allocations = item.allocations.map { alloc ->
                        PurchaseAllocationUiModel(
                            allocationId = alloc.allocationId,
                            chanceNumbers = alloc.chanceNumbers
                        )
                    },
                    organizationId = sub.organizationId,
                    checkoutSessionUrl = sub.checkoutSessionUrl,
                    slug = event?.slug ?: ""
                )
            }
        }
    )
}